import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

gsap.registerPlugin(ScrollTrigger, CustomEase)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  pin() {
    const spacer = document.querySelector('[data-effect-pin-spacer]')
    const tl = gsap.timeline({})

    tl.from(
      this.el,
      {
        scale: 1.1,
        width: window.innerWidth,
        height: window.innerHeight,
      },
      'start',
    );

    let startTriggerDesktop = 'top 75%'; // Default start position for desktop (top 75%)
    let startTriggerMobile = 'top 15%'; // Start position for mobile devices (top 50%)

    // Check if the device is a mobile device (viewport width less than or equal to 768px)
    if (window.innerWidth <= 768) {
        startTriggerDesktop = startTriggerMobile; // Adjust the start position for mobile devices
    }

    ScrollTrigger.create({
        trigger: spacer,
        start: startTriggerDesktop, // Use the adjusted start position
        end: 'bottom 75%',
        animation: tl,
        scrub: 1,
    });
}

  blur() {
    const animation = gsap.timeline({
      paused: true,
      duration: 0.1,
      ease: CustomEase.create('custom', '0.165, 0.84, 0.44, 1'),
    })

    animation.fromTo(
      this.el,
      { filter: 'blur(30px)', opacity: 0 },
      { filter: 'blur(0px)', opacity: 1 },
    )

    ScrollTrigger.create({
      trigger: this.el,
      start: 'top bottom',
      end: 'bottom top',
      animation,
      once: true,
    })
  }

  parallax() {
    if (window.innerWidth < 1024) return;

    const imgs = this.el.querySelectorAll('img');
    const tl = gsap.timeline({})
        .set(imgs, { scale: 1.25, transformOrigin: 'center center' }) // Adjusted scaling
        .from(this.el, { y: 'random(75, 250)' }, 'start') // Adjusted y-axis movement
        .to(imgs, { scale: 1, ease: 'power1.inOut' }, 'start'); // Adjusted scaling easing

    ScrollTrigger.create({
        trigger: this.el,
        start: 'top bottom+=10%', // Adjusted start position
        end: 'bottom bottom-=20%', // Adjusted end position
        animation: tl,
        scrub: 1,
    });
}

  timeline() {
    const element = this.el
    const gradient = this.el.querySelector('[data-timeline-gradient]')
    const start = this.el.querySelector('[data-timeline-start]')
    const borders = this.el.querySelectorAll('[data-timeline-border]')
    const contents = this.el.querySelectorAll('[data-timeline-content]')

    ScrollTrigger.create({
      trigger: this.el,
      start: 'top top',
      end: 'bottom bottom-=800',
      onToggle({ isActive }) {
        element.classList.toggle('text-white', isActive)
        gradient.classList.toggle('opacity-0', !isActive)
        start.classList.toggle('text-white', isActive)
        start.classList.toggle('text-black', !isActive)
        start.classList.toggle('bg-black', isActive)
        borders.forEach((border) => border.classList.toggle('border-black', !isActive))
        contents.forEach((content) => content.classList.toggle('max-md:bg-black', isActive))
      },
    })
  }
}
